import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CtxMapV2 } from 'components/mapV2/contexts/CtxMapV2';
import { useActions } from 'components/mapV2/hooks/useActions';
import { motion } from 'framer-motion';
import { DetailQuery_moment } from 'graphql/query/__generated__/DetailQuery';
import { EFonts } from 'libs/styles/styling';
import { useContext } from 'react';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    story: DetailQuery_moment;
}

export const MapV2ModalDetailCompact = (props: Props): JSX.Element => {
    const ctxMapV2 = useContext(CtxMapV2);
    const actions = useActions();
    const story = props.story;

    if (!story) {
        return null;
    }

    function openModal() {
        ctxMapV2.mobileModalState.setSize('large');
    }

    function closeModal() {
        actions.closeModal();
    }

    return (
        <S_MapV2ModalDetailCompact className={props.className} onClick={openModal}>
            <motion.div {...PULSING}>
                <S_Image $imageUrl={story.header?.imageUrl} />
            </motion.div>
            <S_Title>{story.header?.title}</S_Title>
            <S_CrossIcon
                icon={['far', 'xmark']}
                onClick={(e) => {
                    closeModal();
                    e.stopPropagation();
                }}
            />
        </S_MapV2ModalDetailCompact>
    );
};

const S_MapV2ModalDetailCompact = styled.div`
    display: flex;
    flex-direction: row;
    gap: 15px;
    align-items: center;
    padding: 10px 20px 0px 20px;
    cursor: pointer;
    position: relative;
`;

const S_Image = styled.div<{ $imageUrl: string }>`
    background-image: url(${(props) => props.$imageUrl});
    background-size: cover;
    background-position: center;
    width: 62px;
    height: 45px;
    border-radius: 10px;
`;

const S_Title = styled.div`
    font-family: ${EFonts.InterSemiBold};
    font-size: 15px;
    line-height: 21px;
    width: 212px;
    text-overflow: ellipsis;
`;

const S_CrossIcon = styled(FontAwesomeIcon)`
    color: #000;
    position: absolute;
    right: 10px;
    top: -28px;
    font-size: 22px;
    padding: 10px;
`;

//pulsing motion animation
const PULSING = {
    animate: {
        scale: [1, 1.1, 1],
        transition: {
            duration: 1.5,
            ease: 'easeInOut',
            repeat: Infinity
        }
    }
};
